import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Lang } from '../models/lang';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HeadLinkService {

  constructor(@Inject(DOCUMENT) private dom) { }

  setCanonicalURL(url?: string) {
    const canURL = url === undefined ? this.dom.URL : url;
    const canonicalElem = this.dom.querySelector('link[rel="canonical"]');
    if (canonicalElem) {
      // 更新
      canonicalElem.setAttribute('href', canURL);
      return;
    }
    // 新規追加
    const link: HTMLLinkElement = this.dom.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', canURL);
    this.dom.head.appendChild(link);
  }

  setAlternate(url: string, lang: Lang) {
    const regExp = new RegExp(`^${environment.baseUrl}/${lang}/`);
    const hreflang = lang === 'ja' ? 'en' : 'ja';
    const alternateURL = url.replace(regExp, `${environment.baseUrl}/${hreflang}/`);
    const alternateElem = this.dom.querySelector('link[rel="alternate"]');
    if (alternateElem) {
      // 更新
      alternateElem.setAttribute('href', alternateURL);
      alternateElem.setAttribute('hreflang', hreflang);
      return;
    }
    // 新規追加
    const link: HTMLLinkElement = this.dom.createElement('link');
    link.setAttribute('rel', 'alternate');
    link.setAttribute('href', alternateURL);
    link.setAttribute('hreflang', hreflang);
    this.dom.head.appendChild(link);
  }

  setNotoSansLink() {
    const link: HTMLLinkElement = this.dom.createElement('link');
    link.setAttribute('rel', 'stylesheet');
    link.setAttribute('type', 'text/css');
    link.setAttribute('href', 'https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700&display=swap');
    this.dom.head.appendChild(link);
  }

}
